// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--Dg7tn","content":"a10a3f92e9--content--uVLPw","text":"a10a3f92e9--text--Odqzr"};